<template>
  <div class="wrapper">
    <div class="nav-section">
      <a
        class="nav-back"
        @click="navToTenantTab()"
      >{{ $t('back') }}</a>
      <div class="header-name">
        {{ getHeaderName() }}
      </div>
    </div>

    <div class="table-wrapper tenancies-table-wrapper">
      <div class="table-caption">
        {{ $t('tenancy.tenancyRecordList') }}
      </div>
      <table>
        <thead>
          <tr>
            <th
              v-for="(header, index) in filteredTenancyHeaders"
              :key="`tenacy_header_${index}`"
              :class="header.class"
              @click="sortTenanciesBy(header.code)"
            >
              {{ header.name }} {{ orderbyAttr === header.code ? reverse ? '&#9660;' : '&#9650;' : null }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in tenancies"
            :key="`tenancy_user_${index}`"
          >
            <td>
              <router-link
                class="name-hyper-link"
                :to="{name:'ccdTenancyTenantView', params:{id:item.id}}"
              >
                {{ item.name || '--' }}
              </router-link>
            </td>
            <td>{{ deep(item, 'TenancyAccount.contactFirstName') || '--' }}</td>
            <td>{{ deep(item, 'TenancyAccount.contactLastName') || '--' }}</td>
            <td>
              <input
                v-if="deep(item, 'TenancyAccount.isAdmin')"
                :id="`settings-tenants-checkbox-is-master-${index}`"
                type="checkbox"
                :disabled="true"
                :checked="true"
              >
              <span v-else>-</span>
            </td>
            <td v-if="enableTenantProjectsFeature">
              <input
                v-if="!!item.TenancyAccount.perms['TenantProject']"
                :id="`settings-tenants-checkbox-is-projects-${index}`"
                type="checkbox"
                :disabled="true"
                :checked="true"
              >
              <span v-else>-</span>
            </td>
            <td v-if="enableTenantProjectsFeature">
              <input
                v-if="!!item.TenancyAccount.perms['HandoverTakeback']"
                :id="`settings-tenants-checkbox-is-hotb-${index}`"
                type="checkbox"
                :disabled="true"
                :checked="true"
              >
              <span v-else>-</span>
            </td>
            <td v-if="enableWorkPermitsFeature">
              <input
                v-if="!!item.TenancyAccount.perms['StandaloneWorkPermits']"
                :id="`settings-tenants-checkbox-is-standaloneWP-${index}`"
                type="checkbox"
                :disabled="true"
                :checked="true"
              >
              <span v-else>-</span>
            </td>
            <td>
              <input
                v-if="!!item.TenancyAccount.perms['TenancyRecord']"
                :id="`settings-tenants-checkbox-is-manage-${index}`"
                type="checkbox"
                :disabled="true"
                :checked="true"
              >
              <span v-else>-</span>
            </td>

            <td>{{ dateUtil.formatDate(deep(item, 'TenancyAccount.invitedAt'), true) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      v-show="false"
      class="table-wrapper project-table-wrapper"
    >
      <div class="table-caption">
        {{ $t('tenancy.projectList') }}
      </div>
      <table>
        <thead>
          <tr>
            <th
              v-for="(header, index) in projectHeaders"
              :key="`project_header_${index}`"
              :class="header.class"
              @click="sortBy(header.code)"
            >
              {{ header.name }} {{ orderProjectAttr === header.code ? reverseProjects ? '&#9660;' : '&#9650;' : null }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in projects"
            :key="`TP_detail_${index}`"
          >
            <td>{{ item.name || '--' }}</td>
            <td>{{ item.tenancyName || '--' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import lodash from 'lodash'

import { getTenantById } from '@/api/users/request'
import { getFullnameSorts } from '@/utils/fullName'
import dateUtil from '@/utils/dateUtil'
import EventBus from '@/utils/eventBus'
import { tenancyTypeMap } from '@/utils/locale'
import { mapGetters } from 'vuex'

export default {
  name: 'TenancyUserDetail',
  beforeRouteLeave (to, from, next) {
    if (to.name === 'setting-users' && to.query.from !== 'tenancyDetail') {
      next(false)
    } else {
      next()
    }
  },
  data () {
    const tenancyHeaders = [{
      code: 'name',
      name: this.$t('company.titles.tenancyRecord'),
    },
    ...getFullnameSorts().map((item) => ({
      code: item.value,
      name: this.$t(`contact.basic.${item.label}`),
    })),
    {
      code: 'admin',
      name: this.$t('tender.isMasterAccount'),
    }, {
      code: 'projects',
      name: this.$t('tender.fitoutAndReinstatementProjects'),
    }, {
      code: 'hotb',
      name: this.$t('tender.handoverTakeback'),
    }, {
      code: 'standaloneWP',
      name: this.$t('tender.standaloneWorkPermits'),
    }, {
      code: 'manage',
      name: this.$t('tender.adminTenancyRecord'),
    }, {
      code: 'invitedAt',
      name: this.$t('invitedAt'),
    },
    ]
    const projectHeaders = [{
      code: 'name',
      name: this.$t('project.name'),
    }, {
      code: 'tenancyName',
      name: this.$t('company.titles.tenancyRecord'),
    },
    ]
    return {
      deep,
      dateUtil,
      user: null,
      tenancyHeaders,
      projectHeaders,
      reverse: 0,
      reverseProjects: 0,
      orderbyAttr: 'name',
      orderProjectAttr: 'name',
    }
  },
  computed: {
    ...mapGetters('regions', ['enableTenantProjectsFeature', 'enableWorkPermitsFeature']),
    tenancies () {
      const result = lodash.orderBy((this.user && this.user.tenancies) || [], this.orderbyAttr)
      return this.reverse ? result.reverse() : result
    },
    projects () {
      const result = this.tenancies.map(tenancy => {
        return {name: `${tenancy.name} Project`, tenancyName: tenancy.name}
      })
      return this.reverseProjects ? result.reverse() : result
    },
    filteredTenancyHeaders () {
      return this.tenancyHeaders.filter(item => {
        switch (item.code) {
          case 'hotb':
          case 'projects':
            return this.enableTenantProjectsFeature

          case 'standaloneWP':
            return this.enableWorkPermitsFeature

          default:
            return true
        }
      })
    },
  },
  async mounted () {
    this.user = await getTenantById(this.$router.currentRoute.params.id)
    this.formatTenancies(this.user.tenancies)
  },
  methods: {
    getHeaderName () {
      return this.user ? this.user.username : '--'
    },
    navToTenantTab () {
      this.$router.push({name: 'setting-users', query: {from: 'tenancyDetail'}})
      EventBus.emit('active-user-tab', 'tenant')
    },
    sortTenanciesBy (attr) {
      if (attr === 'name') {
        this.reverse = !this.reverse
        this.orderbyAttr = attr
      }
    },
    sortBy (attr) {
      if (this.orderProjectAttr === attr) {
        this.reverseProjects = !this.reverseProjects
      }
      this.orderProjectAttr = attr
    },
    formatTenancies (tenancies = []) {
      tenancies.forEach(tenancy => {
        if (tenancy.company) {
          const type = tenancyTypeMap[tenancy.type]
          tenancy.name = `${tenancy.buildingCode || '--'}(${type})/${tenancy.company.name || tenancy.company.mailingName}`
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/tender/view';

.tab-content {
  padding: 0 24px 12px 24px;
}

.nav-section{
  position: relative;
  padding: 0 0 20px 0;
  line-height: 28px;
  border-bottom: 1px solid #e0e0e0;
  a {
    position: absolute;
    left: 0;
    padding-left: 0;
    font-size: 14px;
    color: #0c3a58;
  }
  .header-name {
    display: block;
    padding-left: 60px;
    height: 28px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
}

.tenancies-table-wrapper {
  margin-top: 22px;
  tr>td:not(:first-child), tr>th:not(:first-child) {
    text-align: center;
  }
}

.project-table-wrapper {
  margin-top: 30px;
}

.table-caption {
  text-align: left;
  font-size: 20px;
  line-height: 24px;
  padding-left: 0px;
  font-weight: 700;
  margin-bottom: 15px;
}

.checkbox {
  cursor: hand;
}

</style>
